import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';

export function TrialExpiredModal({ open, onClose, detail }) {
  const navigate = useNavigate();

  const handleGoToBilling = () => {
    onClose();
    navigate('/billing');
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={() => {}} title="Aktif Aboneliğiniz Yok" size="md">
      <div className="text-center py-4">
        <AlertCircle size={48} className="mx-auto text-amber-500 mb-4" />

        <p className="text-base text-slate-700 font-medium mb-2">
          {detail?.trial_expired
            ? 'Deneme süreniz doldu'
            : 'Aboneliğiniz aktif değil'}
        </p>

        <p className="text-sm text-slate-500 mb-6 max-w-md mx-auto">
          Fieldpin'i kullanmaya devam etmek için bir plan seçin.
          Mevcut verileriniz korunur.
        </p>

        <Button onClick={handleGoToBilling} size="lg">
          Plan Seç ve Devam Et
        </Button>
      </div>
    </Modal>
  );
}
